import { render, staticRenderFns } from "./CacheUpdater.vue?vue&type=template&id=2fe93f6c&"
import script from "./CacheUpdater.vue?vue&type=script&lang=js&"
export * from "./CacheUpdater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports